<template>
  <div class="the-header-component w-100">
    <ul class="the-header-component-container d-flex flex-nowrap">
      <Menu class="header-item" icon="bars" :left="true" :force-open="drag.board" :hover="!isMobileDevice">
        <TheHeaderBoard
          v-for="board in alpabetOrderedBoards"
          :key="'menu_header_board_' + board.id"
          class="menu-item"
          :class="{ active: activeBoard == board }"
          :board="board"
          @click="setActive(board)"
        />
      </Menu>

      <!--
      <TheHeaderBoard
        v-if="activeBoard"
        :class="{ 'text-truncate': isMobileDevice }"
        :board="activeBoard"
        :active="isMobileDevice ? null : activeBoard"
        @click="startEdit(activeBoard)"
      />
          v-for="board in boardsExceptActive"
          -->

      <TheHeaderBoard
        v-if="activeBoard && isMobileDevice"
        :class="{ 'text-truncate': isMobileDevice }"
        :board="activeBoard"
        @click="startEdit(activeBoard)"
      />

      <div class="d-flex flex-fill overflow-x-auto d-scrollbar-none" v-if="!isMobileDevice">
        <TheHeaderBoard
          v-for="board in boards"
          :key="'header_board_' + board.id"
          :board="board"
          :active="isMobileDevice ? null : activeBoard"
          @click="setActive(board)"
          @dblclick="startEdit(board)"
        />
      </div>

      <li class="header-item addnew" @click="addBoardWindow">
        <font-awesome-icon icon="plus" />
      </li>

      <div class="ml-auto d-flex flex-row flex-nowrap">
        <div class="desktop d-flex flex-row flex-nowrap">
          <div class="header-item archive" :class="{ active: showArchive }" @click="switchShowArchive()">
            <font-awesome-icon icon="archive" />
          </div>
          <div class="header-item history" :class="{ active: showHistory }" @click="switchShowHistory()">
            <font-awesome-icon icon="history" />
          </div>
          <div class="header-item messages" :class="{ active: showMessages }" @click="switchShowMessages()">
            <font-awesome-icon :icon="['far', 'comment']" />
          </div>
        </div>
        <Menu
          class="header-item"
          :hover="!isMobileDevice"
          :title="isMobileDevice ? null : user.name"
          :icon="isMobileDevice ? 'ellipsis-v' : null"
        >
          <ul>
            <li class="menu-item theme" @click="switchTheme()">
              <font-awesome-icon :icon="theme == 'dark' ? 'sun' : 'moon'" :style="{ color: 'yellow' }" />
              <span class="ml-1">{{ theme == "dark" ? "Светлая тема" : "Темная тема" }}</span>
            </li>
            <li class="menu-item archive mobile" :class="{ active: showArchive }" @click="switchShowArchive()">
              <font-awesome-icon icon="archive" />
              <span class="ml-1">Архив</span>
            </li>
            <li class="menu-item history mobile" :class="{ active: showHistory }" @click="switchShowHistory()">
              <font-awesome-icon icon="history" />
              <span class="ml-1">История</span>
            </li>
            <li class="menu-item messages mobile" :class="{ active: showMessages }" @click="switchShowMessages()">
              <font-awesome-icon :icon="['far', 'comment']" />
              <span class="ml-1">Сообщения</span>
            </li>

            <li class="menu-item settings" @click="settings()">
              <font-awesome-icon icon="cog" />
              <span class="ml-1">Настройки</span>
            </li>

            <li class="menu-item signout" @click="signOut()">
              <font-awesome-icon icon="sign-out-alt" />
              <span class="ml-1">Выйти</span>
            </li>
          </ul>
        </Menu>
      </div>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import TheHeaderBoard from "./TheHeaderBoard.vue";
import Menu from "@/components/general/Menu.vue";

import SmoothDndHelpers from "@/common/smoothDndHelpers";

import { SWITCH_SHOW_HISTORY, SWITCH_SHOW_ARCHIVE, SWITCH_SHOW_MESSAGES } from "@/store/actions.type";
import urlManager from "../../common/urls";

export default {
  name: "TheHeader",
  components: { TheHeaderBoard, Menu },
  computed: {
    ...mapGetters(["user", "isMobileDevice"]),
    ...mapState("boards", { boards: "all", activeBoard: "active" }),
    ...mapState("users", { user: "active" }),
    ...mapState("theme", { theme: "active" }),
    ...mapState(["showHistory", "showArchive", "showMessages", "drag"]),
    boardsExceptActive() {
      return this.boards.filter((b) => b != this.activeBoard);
    },
    dropPlaceholderOptions() {
      return {
        className: "drop-preview",
        animationDuration: "150",
        showOnTop: true
      };
    },
    alpabetOrderedBoards() {
      const boards = this.boards ? this.boards.slice(0) : [];
      boards.sort((b1, b2) => b1.title.localeCompare(b2.title));
      return boards;
    }
  },
  methods: {
    getChildPayload(index) {
      return {
        index: index,
        obj: null,
        item: this.boards[index],
        items: this.boards
      };
    },
    onDragStart(event) {
      this.smoothDndHelpers.onDragStart(event);
    },
    onDrop(dest, event) {
      this.smoothDndHelpers.onDrop(dest, event);
    },
    switchTheme() {
      this.$store.dispatch("theme/switchTheme");
    },
    switchShowHistory() {
      this.$store.commit(SWITCH_SHOW_HISTORY);
    },
    switchShowMessages() {
      this.$store.commit(SWITCH_SHOW_MESSAGES);
    },
    switchShowArchive() {
      if (!this.activeBoard) return;

      this.$store.dispatch("boards/getArchivedCards", this.activeBoard);
      this.$store.commit(SWITCH_SHOW_ARCHIVE);
    },
    setActive(board) {
      this.$store.dispatch("boards/activateBoard", board);
    },
    startEdit(board) {
      urlManager.toEditBoard(board);
    },
    addBoardWindow() {
      this.$modal.show("NewBoard");
    },
    switchSelectingBoard() {
      this.selectingBoard = !this.selectingBoard;
    },
    settings() {
      this.$router.push({ name: "settings" });
    },
    signOut() {
      this.$store.dispatch("users/signout");
    }
  },
  data() {
    return {
      smoothDndHelpers: new SmoothDndHelpers(this.$order),
      selectingBoard: false,
      edit: {
        board: null,
        newTitle: ""
      }
    };
  },
  mounted() {
    const _this = this;
    this.smoothDndHelpers.dragStartedCallbacks.push(() => {
      _this.$store.commit("DRAG_BOARD", true);
    });

    this.smoothDndHelpers.onDropGuards.push(() => {
      return !_this.drag.board;
    });

    this.smoothDndHelpers.dragEndIfNotDropCallbacks.push(() => {
      _this.$store.commit("DRAG_BOARD", false);
    });

    this.smoothDndHelpers.beforeDropCallbacks.push(() => {
      _this.$store.commit("DRAG_BOARD", false);
    });

    this.smoothDndHelpers.droppedCallbacks.push((payload) => {
      //if any board doen't have board order we must set it.
      _this.boards.forEach((b) => {
        if (b.hasBoardOrder || b == payload.item) return;

        _this.$store.dispatch("boards/move", {
          board: b,
          order: b.order
        });
      });

      _this.$store.dispatch("boards/move", {
        board: payload.item,
        order: payload.order
      });
    });
  }
};
</script>

<style lang="postcss">
.the-header-component {
  background-color: var(--bg-header);
  color: var(--color-header);
  max-heigth: var(--header-height) !important;
  heigth: var(--header-height) !important;

  .header-item {
    display: inline-block;
    width: fit-content;
    text-align: center;
    padding: 9px 16px;

    &:hover {
      background-color: #111;
    }
  }

  .menu-item {
    display: block;
    width: 100%;
    padding: 9px 16px;
    text-align: left;

    &:hover {
      background-color: #111;
    }
  }

  .active {
    background-color: var(--bg-active);
  }

  a {
    text-decoration: none;
  }

  .usermenu {
  }
}
</style>
